import React from 'react';

type AvailabilityConfirmationDialogProps = {
  onConfirm(): void;
  onCancel(): void;
  pending?: boolean;
};

export const AvailabilityConfirmationDialog: React.FC<AvailabilityConfirmationDialogProps> = ({
  onConfirm,
  onCancel,
  pending = false,
}) => (
  <div className="dialog">
    <div className="dialog-contents">
      <p className="dialog-title">Are You Sure?</p>
      <p className="dialog-description">Are you sure you want to delete this?</p>
      <div className="dialog-actions">
        <button type="button" className="btn btn-default btn-lg" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger btn-lg" onClick={onConfirm} disabled={pending}>
          Continue
        </button>
      </div>
    </div>
  </div>
);
